import Accordion from './views/accordion.c';
export default Accordion;
